import { Button, FormControl, Grid } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import GKModal from "components/GKModal";
import GKTextField from "components/GKTextField";
import { useState } from "react";
import axiosInstance from "utils/axiosInstance";

const CreateAdvisorModal = ({ open, setOpen, refetch }) => {
  const handleClose = () => setOpen(false);

  const [phone, setPhone] = useState("");

  const { mutate: createAdvisor, isLoading } = useMutation({
    mutationKey: ["CREATE_ADVISOR"],
    mutationFn: (values) =>
      axiosInstance.post(`/super_admin/create_advisor/`, values),
    onSuccess: () => {
      refetch();
      setOpen(false);
    },
    onError: () => {
      // Handle error
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phone) {
      createAdvisor({ phone });
    }
  };

  return (
    <GKModal
      modalTitle="Create Advisor"
      open={open}
      setOpen={setOpen}
      footer={
        <>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            variant="outlined"
            size="medium"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            variant="contained"
            size="medium"
            type="submit"
            form="add-advisor-form"
            disabled={isLoading || !phone} // Disable button if no phone number
          >
            {isLoading || "Create Advisor"}
          </Button>
        </>
      }
    >
      <form id="add-advisor-form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="Phone"
                type="number"
                name="phone"
                onChange={(e) => setPhone(e.target.value)}
                fullWidth
                required
              />
            </FormControl>
          </Grid>
        </Grid>
      </form>
    </GKModal>
  );
};

export default CreateAdvisorModal;
